import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-dashboard-navigator',
  templateUrl: './dashboard-navigator.component.html',
  styleUrls: ['./dashboard-navigator.component.css']
})
export class DashboardNavigatorComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
